export class List {
    id: number;
    name: string;
    fileName: string;
    file: Blob;
    skipFirstLine: boolean = true;
    type: string;
    columnMapping: object;
    matchOnJobHistory: boolean = false;
    isPublic: boolean = false;
    tags: number[] = []
}
